module.exports = __webpack_public_path__ + "cc46936e8e88ee146a472d2cc12f6c60.png";